import React, { useEffect, useRef, useState } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

/*
https://stackoverflow.com/questions/28868071/onchange-event-using-react-js-for-drop-down
*/

const PicklistAnswer = ({ question, disabled, responseHandler, inputLabel, error, validateField }) => {
    const divRef = useRef(null);
    const id = question.questionID;
    const options = question.answers.map((v) => {
        const aid = v.questionnaireAnswerID;
        return {
            key: `a${id}_${aid}`,
            value: aid,
            label: v.label,
            selected: aid === question.response.questionnaireAnswerID
        };
    });
    const selected = options.filter((o) => o.selected);
    const initialValue = selected.length ? selected[0].value : '';

    const [selectedOption, setSelectedOption] = useState(initialValue);

    useEffect(() => {
        if (divRef.current) {
            const label = divRef.current.querySelector('label');
            const input = divRef.current.querySelector('input');
            if (label && !label.getAttribute('id')) {
                label.setAttribute('id', question.alias || `q-${id}`);
            }
            if (input && !input?.getAttribute('aria-labelledby')) {
                input.setAttribute('aria-labelledby', question.alias || `q-${id}`);
            }
        }
    });
    return (
        <div ref={divRef}>
            <p>{question.question}</p>
            <FormControl error={error}>
                <FormLabel id={question.alias}>
                    <p>{inputLabel}</p>
                    <Select
                        aria-labelledby={question.alias}
                        disabled={disabled}
                        error={error}
                        value={selectedOption}
                        key={`qpl_${id}`}
                        style={{ width: question.alias === 'autoInsurance' ? 200 : null, top: `-1em` }}
                        inputProps={{
                            className: 'questionnaire-body',
                            style: { color: 'green' }
                        }}
                        onChange={(e) => {
                            const val = e.target.value;
                            setSelectedOption(val);
                            responseHandler(id, val, e);
                            validateField();
                        }}
                    >
                        <MenuItem value="">
                            <font color={error ? 'red' : 'gray'}>Select an option:</font>
                        </MenuItem>
                        {options.map((option) => (
                            <MenuItem key={option.key} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormLabel>
            </FormControl>
        </div>
    );
};

export default PicklistAnswer;
